export default {"src":"/_next/static/media/VendorHeader.cb2d05c4.svg","height":40,"width":733,"blurWidth":0,"blurHeight":0};